export const UVVertexShader = /* glsl */ `varying vec2 vUv;

void main() {
  vUv = uv;
  #ifdef USE_INSTANCING
  vec4 mvPosition = modelViewMatrix * instanceMatrix * vec4( position, 1.0 );
  #else
  vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );
  #endif
  gl_Position = projectionMatrix * mvPosition;
}`;

export const UVTransformVertexShader = /* glsl */ `
varying vec2 vUv;
uniform mat3 uvTransform;

void main() {
  vUv = (uvTransform * vec3(uv, 1)).xy;
  #ifdef USE_INSTANCING
  vec4 mvPosition = modelViewMatrix * instanceMatrix * vec4( position, 1.0 );
  #else
  vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );
  #endif
  gl_Position = projectionMatrix * mvPosition;
}`;
